import { Box, Paper, Typography, Avatar, Stack, Chip, Button } from '@mui/material';
import { Mail, Phone, CalendarDays, Edit, Trash2 } from 'lucide-react';
import { StatusBadge } from '@/components/feedback/StatusBadge';
import { DepartmentBadge } from './DepartmentBadge';

export function TeacherProfileHeader({ teacher, onEdit, onDelete, showActions = true }) {
  if (!teacher) return null;

  return (
    <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} sx={{ alignItems: { xs: 'center', md: 'flex-start' } }}>
        <Avatar
          src={teacher.photo}
          sx={{ width: 120, height: 120, fontSize: 40, bgcolor: 'primary.main' }}
        >
          {teacher.firstName.charAt(0)}
        </Avatar>
        
        <Box sx={{ flexGrow: 1, textAlign: { xs: 'center', md: 'left' } }}>
          <Stack 
            direction={{ xs: 'column', md: 'row' }} 
            spacing={2}
            sx={{
              justifyContent: 'space-between',
              alignItems: { xs: 'center', md: 'flex-start' }
            }}
          >
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                {teacher.firstName} {teacher.lastName}
              </Typography>
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' }, mb: 1 }}>
                <Typography variant="subtitle1" color="text.secondary" fontWeight={500}>
                  {teacher.employeeId}
                </Typography>
                <Typography color="text.disabled">•</Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {teacher.designation}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} sx={{ mb: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
                <DepartmentBadge department={teacher.department} />
                <StatusBadge status={teacher.status} />
              </Stack>
            </Box>

            {showActions && (
              <Stack direction="row" spacing={1}>
                <Button 
                  variant="outlined" 
                  startIcon={<Edit size={18} />}
                  onClick={onEdit}
                >
                  Edit
                </Button>
                {onDelete && (
                  <Button 
                    variant="outlined" 
                    color="error"
                    startIcon={<Trash2 size={18} />}
                    onClick={onDelete}
                  >
                    Delete
                  </Button>
                )}
              </Stack>
            )}
          </Stack>

          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={3} 
            sx={{
              color: 'text.secondary',
              justifyContent: { xs: 'center', md: 'flex-start' }
            }}
          >
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Mail size={16} />
              <Typography variant="body2">{teacher.email}</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <Phone size={16} />
              <Typography variant="body2">{teacher.phone}</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <CalendarDays size={16} />
              <Typography variant="body2">Joined: {teacher.joiningDate}</Typography>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
}
